/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css, keyframes } from '@emotion/react';
import { Fragment } from 'react';
import Typography from '@egalite/ui/Typography';
import Icon from '@egalite/ui/Icon';
import IconButton from '@egalite/ui/Buttons/IconButton';
import cn from '@egalite/ui/Utils/cn';

const spin = keyframes`
	from {
		transform: scale(1.2) rotate(0);
	}
	50% {
		transform: scale(1.2) rotate(180deg);
	}
	to {
		transform: scale(1.2) rotate(360deg);
	}
`;

const AttachedFileBlock = ({ fileName = null, fileLink = null, loading = false, deletable = false, onDelete = null, className = null }) => {
	return (
		<Fragment>
			<div className="flex flex-basis-full md:flex-[0_0_calc(33%_-_20px)]">
				<a className="w-full" href={fileLink} target="_blank">
					<div className={cn("flex gap-8 justify-between px-16 py-8 rounded-2xl bg-white text-lg text-brand-main print:border print:border-solid print:border-base-grey-4 print:px-16 print:flex-[0_1_auto]", className)}>
						<Typography variant="body2" className='mb-0'>
							{fileName}
						</Typography>
						<div className='flex flex-row gap-4 items-center'>
							{loading ? (
								<Icon
									className="fi fi-br-spinner -mr-3 ml-4 mt-2"
									css={{
										'&:before': css`
											display: inline-block;
											animation: ${spin} 1s linear infinite;
										`,
									}}
								/>
							) : (
								<Icon icon="download" css={{ height: 24, width: 24, svg: { height: 24, width: 24 } }} />
							)}
							{deletable ? (
								<IconButton
									title={`Remover arquivo`}
									onClick={e => {
										e.preventDefault();
										e.stopPropagation();
										onDelete();
									}}
									icon={<Icon className="fi fi-br-trash text-2xl -my-3 ml-3 -mr-8 h-16 w-16" />}
								/>
							) : null}
						</div>
					</div>
				</a>
			</div>
		</Fragment>
	);
};

export default AttachedFileBlock;
